import React from "react";
import Label from "./Label";

const ErrorBox = ({ children }) => {
  return <div className="invalid-feedback">{children}</div>;
};

const InputContainer = ({ children }) => {
  return (
    <div className="form-group" style={{ marginBottom: "0.75rem" }}>
      {children}
    </div>
  );
};

const Input = React.forwardRef(
  (
    {
      label,
      name,
      required = false,
      type = "text",
      placeholder,
      errors = {},
      countLabel,
      ...inputProps
    },
    ref
  ) => {
    const hasErrors = Boolean(errors?.message);
    return (
      <InputContainer>
        <Label required={required} htmlFor={name}>
          {label}
        </Label>
        {type === "textarea" ? (
          <>
            <textarea
              name={name}
              id={name}
              type={type}
              placeholder={placeholder ?? label}
              className={`form-control ${hasErrors ? "is-invalid" : ""}`}
              required={required}
              {...inputProps}
              ref={ref}
            />
            <p
              style={{
                textAlign: "end",
                fontSize: "12px",
                fontStyle: "italic",
                paddingTop: "2px",
              }}
            >
              {countLabel}
            </p>
          </>
        ) : (
          <input
            name={name}
            id={name}
            type={type}
            placeholder={placeholder ?? label}
            className={`form-control ${hasErrors ? "is-invalid" : ""}`}
            required={required}
            {...inputProps}
            ref={ref}
          />
        )}
        {hasErrors && <ErrorBox>{errors.message}</ErrorBox>}
      </InputContainer>
    );
  }
);

export default Input;
